<template>
  <div class="subsector livestock">
    <div class="parent-sector">
      <p>Agriculture</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-sm-6">
          <h1>Livestock</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Emissions from livestock include enteric fermentation and manure
                management. Enteric fermentation is a normal mammalian digestive
                process, where gut microbes produce CH₄
                that the animal exhales.
                Livestock manure management produces CH₄ emissions during the
                anaerobic decomposition of manure and N₂O emissions during the
                nitrification and denitrification of the organic nitrogen
                content in livestock manure and urine.
              </p>
              <p>
                From 2015 through 2030, emissions from enteric fermentation and
                manure management are projected to increase 12% and 5%,
                respectively. Livestock populations, which are driven by demand
                for animal products such as meat and milk, dominate emission
                projections. Developing countries are expected to increase their
                livestock populations.
              </p>
              <p>
                Technologically feasible global abatement potential from
                livestock is estimated at 298 MtCO₂e in 2030, a 9% reduction
                compared with the baseline. The total abatement potential is
                expected to remain roughly the same as a percentage of baseline
                emissions through 2050. In 2030, 26% of emission reductions are
                achievable at break-even prices below $0.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartLivestock1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartLivestock2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartLivestock1 from "@/components/agriculture/ChartLivestock1";
import ChartLivestock2 from "@/components/agriculture/ChartLivestock2";

export default {
  components: {
    ChartLivestock1,
    ChartLivestock2
  },
  data() {
    return {
      currentComp: "ChartLivestock1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-green-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
  color: #28530a;
}
.center button {
  position: static !important;
}
</style>
